import axios, {
    AxiosError,
    InternalAxiosRequestConfig,
    AxiosResponse,
} from "axios";

import { acquireToken } from "./auth-provider";

export const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    validateStatus: (status) => {
        // Resolve all HTTP status codes (200\–599\) without throwing
        return status >= 200 && status < 600;
    },
});

API.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        const accessToken = await acquireToken();
        const contentType = getContentType(config);

        config.headers.setAuthorization(`Bearer ${accessToken}`);
        config.headers.setAccept("application/json");
        config.headers.setContentType(contentType);

        return config;
    },
    async (error: AxiosError) => {
        return error.response;
    }
);

API.interceptors.response.use(
    async (response: AxiosResponse) => {
        return response;
    },
    async (error: AxiosError) => {
        return error.response;
    }
);

const getContentType = (config: InternalAxiosRequestConfig): string => {
    const data = config.data;

    const typeChecks: [() => boolean, string][] = [
        [() => data instanceof Blob, "application/octet-stream"],
        [() => data instanceof ArrayBuffer, "application/octet-stream"],
        [() => ArrayBuffer.isView(data), "application/octet-stream"],
    ];

    return typeChecks.find(([check]) => check())?.[1] ?? "application/json";
};
